import { ReactNode, useState } from "react";

export function IconBtn({ title, onClick, children, danger, accent }: {
    title: string; onClick: () => void; children: ReactNode; danger?: boolean; accent?: boolean;
}) {
    const [hov, setHov] = useState(false);
    return (
        <button
            title={title}
            onClick={onClick}
            style={{ width: 30, height: 30, borderRadius: 7, border: `1px solid ${hov ? (danger ? "rgba(224,82,82,0.4)" : accent ? "rgba(191,61,12,0.4)" : "rgba(255,255,255,0.14)") : "var(--border)"}`, background: hov ? (danger ? "rgba(224,82,82,0.10)" : accent ? "var(--or-dim)" : "rgba(255,255,255,0.05)") : "transparent", color: hov ? (danger ? "#e05252" : accent ? "var(--or)" : "var(--text2)") : "var(--text3)", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", transition: "all 0.15s", flexShrink: 0 }}
            onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}>
            {children}
        </button>
    );
}